import React from 'react';

interface RobotIconProps {
  className?: string;
}

export const RobotIcon: React.FC<RobotIconProps> = ({ className = "w-6 h-6" }) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Casque principal */}
      <path d="M7 8.5C7 5.5 9.2 3 12 3s5 2.5 5 5.5v8c0 1.1-.9 2-2 2h-1v-2h1v-8c0-2.2-1.8-4-4-4s-4 1.8-4 4v8h1v2H8c-1.1 0-2-.9-2-2v-8z"/>
      
      {/* Écouteur gauche */}
      <rect x="3" y="10" width="4" height="6" rx="2" fill="currentColor"/>
      
      {/* Écouteur droit */}
      <rect x="17" y="10" width="4" height="6" rx="2" fill="currentColor"/>
      
      {/* Micro */}
      <path d="M10 17h4l-1 3h-2l-1-3z"/>
      <circle cx="12" cy="19" r="1.5" fill="currentColor"/>
      
      {/* Texte AI */}
      <text x="12" y="12" textAnchor="middle" fontSize="6" fontWeight="bold" fill="currentColor">
        AI
      </text>
    </svg>
  );
};